export const RADIANS_PER_DEGREE = 2 * Math.PI / 360;

export function getBoundsOfRectangle(size, rotation) {
  if (!size || !size.width && !size.height) {
    return { width: 0, height: 0 };
  }
  rotation = rotation % 360;
  if (!rotation) {
    return size;
  }
  const theta = rotation * RADIANS_PER_DEGREE;
  const st = Math.sin(theta);
  const ct = Math.cos(theta);
  const w = size.width;
  const h = size.height;
  const x = w / 2;
  const y = h / 2;
  const xct = x * ct;
  const xst = x * st;
  const yct = y * ct;
  const yst = y * st;
  // bottom right
  const x1 = xct - yst;
  const y1 = -xst + yct;
  // top right
  const x2 = xct + yst;
  const y2 = -xst - yct;
  return {
    width: Math.max(Math.abs(x1), Math.abs(x2)) * 2,
    height: Math.max(Math.abs(y1), Math.abs(y2)) * 2,
  };
}
